import React, { createContext, useContext } from 'react'; // eslint-disable-line
import { Product } from '../interfaces/Product';

interface ProductContent {
  product: Product;
}

export const ProductContext = createContext<ProductContent>({
  product: new Product({
    id: '',
    name: '',
    price: { amount: 0, currency: 'EUR', decimals: 2 },
  }),
});

export const useProductContext = () => useContext(ProductContext);
